<template>
  <div class="animated fadeIn">
    <b-row>
      <b-col md="6">
        <FormBranch @submit="submit" :title="'Add Branch'" :form="{}"></FormBranch>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import axios from 'axios'
import FormBranch from '@/views/admin/branch/FormBranch'

export default {
  name: 'addbranch',
  components: {
    FormBranch
  },
  methods: {
    submit (form) {
      let scope = this; 

      form.user = scope.$store.getters.currentUser.id

      axios.post(process.env.VUE_APP_API + '/branch', form, {
      headers: {
        Authorization: 'JWT ' + scope.$localStorage.get('holly-fi-token')
        }
      })
        .then(function (response) {
          scope.$router.push('/admin/branches/list')
        })
        .catch(function (error) {
          console.log(error);
        });
    }
  }
}
</script>

<style scoped>
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}
</style>
